export default "__VITE_ASSET__39bdf352__"